<template>
    <div id="approvedWorkOrderList">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title">Approved Work Order List</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="btn-groups text-right">
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                            <i class="fp-export"></i> Export
                        </a>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content work-order-list">
                        <data-table-filter-config :moduleName="'listApprovedWorkOrder'" ref="filterApprovedWorkOrderList" @cancelSelection="cancelAll"></data-table-filter-config>
                        <section class="bg-white data-table">
                            <custom-pagination
                                :page-changed="onPageChange"
                                :per-page-changed="onPerPageChange" :moduleName="'listApprovedWorkOrder'" :position="'top'">
                            </custom-pagination>
                            <vue-good-table
                                ref="listApprovedWorkOrderTable"
                                mode="remote"
                                title="Approved Work Orders"
                                @on-page-change="onPageChange"
                                @on-selected-rows-change="selectionChanged"
                                @on-column-filter="onColumnFilter"
                                @on-per-page-change="onPerPageChange"
                                @on-sort-change="onSortChange"
                                @on-select-all="onSelectAll"
                                :totalRows="totalRecords"
                                :columns="userColumns"
                                :rows="rows"
                                :pagination-options="{
                                    enabled: false,
                                    position: 'both',
                                    perPage: perPage,
                                    perPageDropdown:dropDownPerPage,
                                    dropdownAllowAll: false,
                                }"
                                :select-options="{
                                    enabled: work_order_value,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                }"
                                :search-options="{
                                    enabled: false,
                                }">
                                <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                    <div :key="key">
                                        <div v-if="props.column.field == 'action'" class='text-center'>
                                            <template v-if="canEditWorkOrder == true && props.row.status.toLowerCase() != 'approved'">
                                                <router-link title="Edit Work Order" class="fp-edit" v-bind:to="{name: 'WorkOrderEdit',params:{id:props.row.id}}"></router-link>
                                            </template>
                                        </div>
                                        <div v-else-if="props.column.field == 'work_order_no' && canViewWorkOrder === true" class='text-center'>
                                            <router-link title="View Work Order" class="color-blue"  v-bind:to="{name: 'WorkOrderView',params:{id:props.row.id},query:{fromUrl:fromUrl}}">{{props.row.work_order_no}}</router-link>
                                        </div>
                                        <div v-else-if="props.column.field == 'customer_unit'" class='text-center'>
                                            <span v-fp-html="props.formattedRow[props.column.field]"></span>
                                        </div>
                                        <div v-else>
                                            {{props.formattedRow[props.column.field]}}
                                        </div>
                                    </div>
                                </template>
                                <div slot="selected-row-actions">
                                    <template v-if="work_order_value == true">
                                        <button v-if="showApproveBtn" id="approveWorkOrderBtn" v-on:click.prevent="workOrderApprove" class="btn btn-primary">Approve</button>
                                    </template>
                                </div>
                            </vue-good-table>
                            <custom-pagination
                                :page-changed="onPageChange"
                                :per-page-changed="onPerPageChange">
                            </custom-pagination>
                        </section>
                        <div class="modal fade work-order-msg-modal" id="work-order-msg-modal" ref="workOrderMsgModal" data-backdrop="true" data-keyboard="false" aria-labelledby="workOrderMsgModal" aria-hidden="true">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title">Message</h5>
                                            <button type="button" class="close" id="btnModalMessageClose" v-on:click="hideMessageModal()">&times;</button>
                                        </div>
                                        <div class="modal-body">
                                            <p>Following Work Order has Sublet Line Item with Sublet Invoice Not Approved : </p>
                                            <template v-if="workOrderArr.length > 0">
                                                <template v-for="(row,index) in workOrderArr">
                                                    <a :key="'i' + index" v-if="index > 0">&nbsp;&nbsp; | &nbsp;&nbsp;</a><span :key="'j' + index"> {{row}}</span>
                                                </template>
                                            </template>
                                        </div>
                                        <div class="modal-footer">
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';
import EventBus from "./event-bus";

export default {
    name: "ApprovedWorkOrderList",
    mixins:[commonMixins,dataTableMixins],
    data: () => ({

        firstLoad: 0,
        permissions: [],
        cantAccessPage: "",
        userColumns:[],
        columns: [
            {
                label: 'Actions',
                field: 'action',
                sortable: false,
            },
            {
                label: '#Work Order',
                field: 'work_order_no',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Work Order No", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" ,//only trigger on enter not on keyup
                }
            },
            {
                label: 'Has Sublet',
                field: 'sublet_item',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "", // placeholder for filter input
                    filterValue: '',
                    filterDropdownItems:['Yes','No'], // initial populated value for this filter
                    trigger: "enter" ,//only trigger on enter not on keyup
                }
            },
            {
                label: 'Has Billable',
                field: 'has_billable',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "", // placeholder for filter input
                    filterValue: '',
                    filterDropdownItems:['Yes','No'], // initial populated value for this filter
                    trigger: "enter" ,//only trigger on enter not on keyup
                }
            },
            {
                label: 'Unit',
                field: 'unit_no',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Unit No.", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Customer Unit',
                field: 'customer_unit',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Customer Unit.", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                html: true
            },
            {
                label: 'Customer',
                field: 'customer_id',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Customer", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'User',
                field: 'user_id',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "User", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Maintenance Type',
                field: 'maintenance_type',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Maintenance Type", // placeholder for filter input
                    filterDropdownItems: ['Preventive Maintenance', 'Federal Maintenance','Other'],
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Open Date',
                field: 'open_date',
                fpFieldType:"date",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Priority',
                field: 'priority',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Priority", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Location',
                field: 'location',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Location", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Status',
                field: 'status',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "All", // placeholder for filter input
                    filterDropdownItems: ['Closed','Approved'],
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
        ],
        flag:"list",
        rows: [],
        totalRecords: 0,
        work_order_value: false,
        loading:false,
        idArr:"",
        pageKey:"_work_order_list_",
        canViewWorkOrder: false,
        showApproveBtn:false,
        canEditWorkOrder: false,
        workOrderArr:[],
        fromUrl:""
    }),
    metaInfo () {
        return {
            title: "Approved Work Order List | " +process.env.COPYRIGHT_NAME
        }
    },
    watch:{

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'list_approved_work_order') {
                        self.cantAccessPage = true;
                    }
                    if (permissions[i].name == 'can_approve_work_order') {
                        self.work_order_value = true;
                    }
                    if (permissions[i].name == 'view_work_order') {
                        self.canViewWorkOrder = true;
                    }
                    if (permissions[i].name == 'add_work_order') {
                        self.canEditWorkOrder = true;
                    }
                }
            }
        }
    },
    created: function() {

    },
    mounted: function() {
        var self = this;
        self.fromUrl = btoa(window.location.pathname);
        self.getPermissions();
    },
    methods: {
        cancelAll: function (cancelAll) {
          this.$refs.listApprovedWorkOrderTable.unselectAllInternal();
        },
        loadList() {
            var self = this;

            var data = this.$refs['listApprovedWorkOrderTable'].selectedRows;
            var use = [];
            for (var i = 0; i < data.length; i++) {
                use.push(self.$refs['listApprovedWorkOrderTable'].selectedRows[i].id)
            }

            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                flag: self.flag,
                all:self.serverParams.selectedAll,
                sort: self.serverParams.sort,
                id:self.idArr,
                selectedRows:use,
                type:"approve"
            };
            self.firstLoad = 1;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/workorder/list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;

                    if(self.flag=='approve') {
                        self.flag = "";
                        if (self.workOrderVal == undefined)
                        {
                            self.$refs.filterApprovedWorkOrderList.clearSelectAll();
                            EventBus.$emit('clear-all-flags', false);
                        }
                        self.workOrderArr = [];
                        if (data.status == "success") {
                            if (data.code == '200') {
                                if (data.content.wo_arr && data.content.wo_arr.length > 0) {
                                    //work order message
                                    self.workOrderArr = data.content.wo_arr;
                                    $("#work-order-msg-modal").modal("show");
                                }else{
                                    self.$swal('','Work Order Approved Successfully','success');
                                }
                                // self.loadList();
                                // return;
                            }
                        }else{
                            if (data.code == '201') {
                                if (data.content.wo_arr && data.content.wo_arr.length > 0) {
                                    //work order message
                                    self.workOrderArr = data.content.wo_arr;
                                    $("#work-order-msg-modal").modal("show");
                                }
                            }
                        }
                        self.loadList();
                        return;

                    }else if (self.flag =='export'){
                        if (data.status == "success") {
                            self.flag = 'list';
                            if ( data.code == "201" ) {
                                alert(data.message);
                            } else {

                                self.excel = data.content.web;
                                var save = document.createElement("a");
                                save.href = self.excel;
                                save.download = data.content.web;
                                save.target = "_blank";

                                document.body.appendChild(save);
                                save.click();
                                document.body.removeChild(save);
                                self.$refs.listApprovedWorkOrderTable.unselectAllInternal();
                                EventBus.$emit("clear-all-flags", false);
                                self.loadList();
                            }
                        }
                    }else{
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;

                            for (var i = 0; i < self.columns.length; i++) {
                                if (self.columns[i].field == 'cost_code') {
                                    console.log(data.costCodes)
                                    self.columns[i].filterOptions.filterDropdownItems = data.costCodes;
                                }
                            }
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if(self.flag=='approve') {
                        self.generateStatusCodeMessage(jqXHR,false,'woapprove')
                    }else{
                        self.generateStatusCodeMessage(jqXHR,false,'wolist')
                    }

                }
            });
        },
        workOrderApprove() {
            var data = this.$refs['listApprovedWorkOrderTable'].selectedRows;
            var self = this;
            var use = [];
            for (var i = 0; i < data.length; i++) {
                use.push(this.$refs['listApprovedWorkOrderTable'].selectedRows[i].id)
            }
            self.idArr = use;
            self.flag = "approve";
            if (confirm('Are you sure that you want to approve this Work Order? ')) {

                self.loadList();

            }

        },
        exportReports: function() {
            this.flag = "export";
            this.loadList();
            EventBus.$emit("clearSelection", false);
        },
        selectionChanged:function(param){
            var self = this;
            self.showApproveBtn = false;
            var statusArr = [];
            if(param.selectedRows.length == 100) {
              EventBus.$emit('clear-selection', false);
            } else {
              EventBus.$emit('clear-all-flags', false);
            }
            var data = this.$refs['listApprovedWorkOrderTable'].selectedRows;
            for (var i = 0;i < data.length;i++) {
                if (data[i] != undefined) {
                    if (data[i] != null) {
                        if (data[i].status != undefined && data[i].status != null) {
                            statusArr.push(data[i].status.toLowerCase());
                        }
                    }
                }
            }
            //check all values in array are equal or not
            const allEqual = arr => arr.every( v => v === arr[0] );
            var found = allEqual(statusArr);
            if ( found ) {
                if (statusArr[0] == "closed") {//Work Order Status is Closed
                    self.showApproveBtn = true;
                }else{
                    self.showApproveBtn = false;
                }
            }
        },
        hideMessageModal() {
            var self = this;
            $("#work-order-msg-modal").modal("hide");
            self.workOrderArr = [];
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ApprovedWorkOrderList.vue